export default function () {
  return 'https://dse.kopfhandundfuss.net'
}



// WEBPACK FOOTER //
// ./src/awsURL.js